<script lang="ts">
	// Signed-in person's picture. Wraps core's Avatar: core sets crossorigin="anonymous" on photo
	// <img>s, and Google profile photos (lh3.googleusercontent.com) send no CORS headers, so they
	// never load. We draw the photo ourselves without crossorigin and fall back to core's
	// initials avatar if it still fails. Drop this once the fix lands in @teal-mongoose/core.
	import { Avatar } from '@teal-mongoose/core/components'
	import { defaultAvatar } from '@teal-mongoose/core/utilities'
	import type { ClassValue } from 'svelte/elements'

	let { name, photo, class: className }: { name: string; photo?: string | null; class?: ClassValue } = $props()

	let failed = $state<string | null>(null)
	const src = $derived(photo && failed !== photo ? photo : null)
</script>

{#if src}
	<img
		{src}
		alt={name}
		class={['size-6 rounded-full object-cover', className]}
		referrerpolicy="no-referrer"
		width="256"
		height="256"
		onerror={() => (failed = src)}
	/>
{:else}
	<Avatar profile={{ name, avatar: defaultAvatar(name) }} class={className} />
{/if}
